// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2037":"880fa4322f150914bea9","5629":"3b7ada8199dec7eb3f88","5677":"7ba1d173c58172ce6b99","7227":"618edcf2fb2f20bc75f8"}[chunkId] + ".js?v=" + {"2037":"880fa4322f150914bea9","5629":"3b7ada8199dec7eb3f88","5677":"7ba1d173c58172ce6b99","7227":"618edcf2fb2f20bc75f8"}[chunkId] + "";
};